import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceTeacher } from '../../hooks/useAuthorizedRequestForTeacher';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { teacherVideoListFormValidation } from '../../validation/Validation';
import { ZodError } from 'zod';
import Swal from 'sweetalert2';
import { ErrorMessage } from '../../validation/validationError';
import { CModal } from '@coreui/react';
import ReactPlayer from 'react-player';

const TeacherUploadedVideo = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const [play, setPlay] = useState(false)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")
    const [played, setPlayed] = useState(0);
    const playerRef = useRef(null);
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [isFullScreen, setFullScreen] = useState(false);

    const [allActive, setAllActive] = useState(true);
    const [allInActive, setAllInActive] = useState(false);

    const initialFormState = {
        academicYearMasterId: "",
        teacherMasterId: "",
        date: "",
        endDate: ""
    }

    const [academicYearList, setAcademicYearList] = useState([])
    const [teacherList, setTeacherList] = useState([])
    const [teacherData, setTeacherData] = useState(initialFormState)

    const [activeVideoList, setActiveVideoList] = useState([]);
    const [inActiveVideoList, setInActiveVideoList] = useState([]);

    const [isActive, setIsactive] = useState(true);
    const [errors, setErrors] = useState([]);

    const [searchValueActive, setSearchValueActive] = useState(null);
    const [searchValueInActive, setSearchValueInActive] = useState(null);
    const searchKeys = ["", "", "", "", "", "", "", ""];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        getAcademicYearList();
        // getActiveVideoList();
        // getInActiveVideoList();
    }, []);

    const getAcademicYearList = () => {
        const apiUrl = `/active-academic-years`;

        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setAcademicYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getApiUrl = (active) => {
        let apiUrl = `/get-teacher-uploaded-video-list?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (teacherData.teacherMasterId !== '') {
            apiUrl += `teacherMasterId=${teacherData.teacherMasterId}&`;
        }
        if (active) {
            apiUrl += `active=${active}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getActiveVideoList = async (active) => {
        try {
            setLoading(true);
            const response = await authorizedAxiosSection.get(getApiUrl(active));
            setActiveVideoList(response.data.result);
        } catch (error) {
            setActiveVideoList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getInActiveVideoList = async (active) => {
        try {
            setLoading(true);
            const response = await authorizedAxiosSection.get(getApiUrl(active));
            setInActiveVideoList(response.data.result);
        } catch (error) {
            setInActiveVideoList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const handleEmptySearchActive = (e) => {
        setSearchValueActive(e.target.value);
    }

    const handleEmptySearchInActive = (e) => {
        setSearchValueInActive(e.target.value);
    }

    const handleAcademicYearChange = (e) => {
        const { name, value } = e.target;
        setTeacherData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                teacherMasterId: ""
            }
        })

        const apiUrl1 = `/academic-year-wise-teacher-data?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&academicYearMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl1)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        const apiUrl2 = `/get-sections-academic-years?sectionMasterId=${sectionMasterId}&academicYearMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                if (response.data.data.length > 0) {
                    const data = response.data.data[0];
                    setTeacherData((prevData) => {
                        return {
                            ...prevData,
                            date: data?.startDate,
                            endDate: data?.endDate
                        }
                    })
                }
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTeacherData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })

        if (value.trim().length !== 0) {
            setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }


    const showTeacherVideoList = async () => {
        try {
            await teacherVideoListFormValidation.parseAsync(teacherData);
            setErrors([]);
            setLoading(true);

            await getActiveVideoList(1);
            await getInActiveVideoList(2);
        } catch (err) {
            if (err instanceof ZodError) {
                setErrors(err.errors);
            } else {
                const errorMsg = err?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        }
    }

    const changeSingleActiveInactive = async (id, active) => {
        setLoading(true);

        const data = {
            instituteMasterId,
            sectionMasterId,
            active,
            ids: [id]  // Pass a single ID inside an array
        };

        try {
            let apiUrl = "/activate-teacher-uploaded-video";
            const response = await authorizedAxiosSection.put(apiUrl, data);
            await getActiveVideoList(1);
            await getInActiveVideoList(2);
            Swal.fire({
                text: response.data.message,
            });
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false);
        }
    };


    const changeBulkActiveInactive = async (active) => {
        setLoading(true);
        let ids = [];
        if (active) {
            ids = activeVideoList.map(item => item.id);
        } else {
            ids = inActiveVideoList.map(item => item.id);
        }

        const data = {
            instituteMasterId,
            sectionMasterId,
            active: !active,
            ids
        }

        try {
            let apiUrl = "/activate-teacher-uploaded-video";
            const response = await authorizedAxiosSection.put(apiUrl, data);
            await getActiveVideoList(1);
            await getInActiveVideoList(2);
            Swal.fire({
                text: response.data.message,
            })
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false);
        }
    }




    const handleInputReset = () => {
        setTeacherData(initialFormState);
        setActiveVideoList([]);
        setInActiveVideoList([]);
        setErrors([]);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Teacher Uplaoded Video</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-school"></i>Teacher Uplaoded Video</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="academicYearMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleAcademicYearChange} value={teacherData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            academicYearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="academicYearMasterId" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Teacher :</label>
                                                    <select class="form-select" aria-label="Default select example" name='teacherMasterId' onChange={handleInputChange} value={teacherData.teacherMasterId}>
                                                        <option selected value={''} disabled>Select Teacher</option>
                                                        {
                                                            teacherList?.map((teacher) => {
                                                                return <option value={teacher.id}>{teacher.teacherName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errors} field="teacherMasterId" />
                                                </div>


                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={showTeacherVideoList}>Show</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <button className={`${isActive ? 'active' : ''} btn btn-light btn-width`} onClick={() => setIsactive(true)}>Active List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${isActive ? '' : 'active'} btn btn-light btn-width`} onClick={() => setIsactive(false)}>Inactive List</button>
                                                            </div>
                                                        </div>

                                                        {!isActive &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                {/* <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueInActive}
                                                                        onChange={handleEmptySearchInActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchInActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchInActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div> */}
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">Syllabus</th>
                                                                            <th scope="col">Subject</th>
                                                                            <th scope='col'>Lesson</th>
                                                                            <th scope='col'>Topic</th>
                                                                            <th scope='col'>Sub Topic</th>
                                                                            <th scope='col'>Tag</th>
                                                                            <th scope="col">Video</th>
                                                                            <th scope='col'>
                                                                                Action
                                                                                {inActiveVideoList.length > 0 && <div className={`toggle-container ${allInActive ? 'active' : ''}`} onClick={() => changeBulkActiveInactive(false)} >
                                                                                    <div className="toggle-background"></div>
                                                                                    <div className="toggle-switch"></div>
                                                                                </div>}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            inActiveVideoList?.length > 0 ?
                                                                                inActiveVideoList?.map((teacher, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{/*startIndexActive +*/ index + 1}</th>
                                                                                            <td>{teacher?.type === "A" ? teacher?.syllabusStructureMasterDetails?.syllabusStructureName : teacher.type === "I" ? teacher.instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName : teacher.sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.subjectMasterDetails?.subjectName : teacher?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.lessonMasterDetails?.lessonName : teacher?.type === "I" ? teacher?.instituteLessonMasterDetails?.instituteLessonName : teacher?.sectionLessonMasterDetails?.sectionLessonName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.topicMasterDetails?.topicName : teacher?.type === "I" ? teacher?.instituteTopicMasterDetails?.instituteTopicName : teacher?.sectionTopicMasterDetails?.sectionTopicName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.subTopicMasterDetails?.subTopicName : teacher?.type === "I" ? teacher?.instituteSubTopicMasterDetails?.instituteSubTopicName : teacher?.sectionSubTopicMasterDetails?.sectionSubTopicName}</td>
                                                                                            <td>{teacher?.tagMasterDetails?.tagName}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setShowPdfLink(teacher?.filePath)
                                                                                                    setVisible(true)
                                                                                                }}><i class="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div
                                                                                                    className={`toggle-container ${teacher.isActive ? 'active' : ''}`}
                                                                                                    onClick={() => changeSingleActiveInactive(teacher.id, !teacher.isActive)}
                                                                                                >
                                                                                                    <div className="toggle-background"></div>
                                                                                                    <div className="toggle-switch"></div>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Inactive Teachers Video Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                {/* <Pagination currPage={currPageInActive} setCurrPage={setCurrPageInActive} totalPages={totalPagesInActive} itemsPerPage={itemsPerPageInActive} setItemsPerPage={setItemsPerPageInActive} totalItem={inActiveList.length} /> */}
                                                            </div>}

                                                        {isActive &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                {/* <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueActive}
                                                                        onChange={handleEmptySearchActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div> */}
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">Syllabus</th>
                                                                            <th scope="col">Subject</th>
                                                                            <th scope='col'>Lesson</th>
                                                                            <th scope='col'>Topic</th>
                                                                            <th scope='col'>Sub Topic</th>
                                                                            <th scope='col'>Tag</th>
                                                                            <th scope="col">Video</th>
                                                                            <th scope='col'>
                                                                                Action
                                                                                {activeVideoList.length > 0 && <div className={`toggle-container ${allActive ? 'active' : ''}`} onClick={() => changeBulkActiveInactive(true)} >
                                                                                    <div className="toggle-background"></div>
                                                                                    <div className="toggle-switch"></div>
                                                                                </div>}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            activeVideoList?.length > 0 ?
                                                                                activeVideoList?.map((teacher, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{/*startIndexActive +*/ index + 1}</th>
                                                                                            <td>{teacher?.type === "A" ? teacher?.syllabusStructureMasterDetails?.syllabusStructureName : teacher.type === "I" ? teacher.instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName : teacher.sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.subjectMasterDetails?.subjectName : teacher?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.lessonMasterDetails?.lessonName : teacher?.type === "I" ? teacher?.instituteLessonMasterDetails?.instituteLessonName : teacher?.sectionLessonMasterDetails?.sectionLessonName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.topicMasterDetails?.topicName : teacher?.type === "I" ? teacher?.instituteTopicMasterDetails?.instituteTopicName : teacher?.sectionTopicMasterDetails?.sectionTopicName}</td>
                                                                                            <td>{teacher?.type === "A" ? teacher?.subTopicMasterDetails?.subTopicName : teacher?.type === "I" ? teacher?.instituteSubTopicMasterDetails?.instituteSubTopicName : teacher?.sectionSubTopicMasterDetails?.sectionSubTopicName}</td>
                                                                                            <td>{teacher?.tagMasterDetails?.tagName}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setShowPdfLink(teacher?.filePath)
                                                                                                    setVisible(true)
                                                                                                }}><i class="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <div
                                                                                                    className={`toggle-container ${teacher.isActive ? 'active' : ''}`}
                                                                                                    onClick={() => changeSingleActiveInactive(teacher.id, !teacher.isActive)}
                                                                                                >
                                                                                                    <div className="toggle-background"></div>
                                                                                                    <div className="toggle-switch"></div>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Active Teachers Video Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                {/* <Pagination currPage={currPageActive} setCurrPage={setCurrPageActive} totalPages={totalPagesActive} itemsPerPage={itemsPerPageActive} setItemsPerPage={setItemsPerPageActive} totalItem={activeList.length} /> */}
                                                            </div>}

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                backdrop="static"
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className={isFullScreen ? "full_scr_view" : ""}
            >
                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                <div className="test test-player">
                    <ReactPlayer
                        ref={playerRef}
                        url={showPdfLink}
                        playing={play}
                        volume={volume}
                        onProgress={handleProgress}
                        playbackRate={playbackRate}
                    >
                    </ReactPlayer>
                    <div className="overlay-layer">
                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                    </div>
                </div>
                <div className="video_content_bottom">
                    <div className="video_progress">
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step="any"
                            value={played}
                            onChange={handleSeekChange}
                            className="input_slider"
                        />
                    </div>


                    <div className='play_pause_sound'>
                        <div className='sound'>
                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                            {volume >= 0.5 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-high"></i>
                            </button>}
                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-low"></i>
                            </button>}
                            {volume == 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-xmark"></i>
                            </button>}

                            <div className='sound_bar'>
                                <input
                                    type="range"
                                    value={volume}
                                    onChange={handleVolumeChange}
                                    min="0"
                                    max="1"
                                    step="0.01"
                                    className="input_slider"
                                />
                            </div>
                        </div>
                        <div className='playbeack_speed'>
                            <span>Playback speed</span>
                            <select onClick={handleSpeedChange}>
                                <option value={0.25}>0.25</option>
                                <option value={0.5}>0.5</option>
                                <option value={0.75}>0.75</option>
                                <option selected value={1}>Normal</option>
                                <option value={1.25}>1.25</option>
                                <option value={1.5}>1.5</option>
                                <option value={1.75}>1.75</option>
                            </select>
                        </div>
                        <div className='fullscreen_mode'>
                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                        </div>
                    </div>
                </div>
            </CModal>
        </>
    )
};

export default TeacherUploadedVideo;